<template>
  <el-dialog
    v-model="dialogVisible"
    class="contact-dialog"
    title="联系我们"
    width="680px"
    destroy-on-close
  >
    <!-- <div class="dialog-tip">
      请完善信息，我们会尽快与您联系。模糊部分已使用表单占位，后续可直接替换。
    </div> -->

    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-position="top"
      class="contact-form"
    >
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" />
      </el-form-item>

      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入联系电话" />
      </el-form-item>

      <el-form-item label="电子邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入电子邮箱" />
      </el-form-item>

      <el-form-item class="contact-form__full" label="详细地址" prop="area">
        <el-input v-model="form.area" placeholder="请输入地址信息" />
      </el-form-item>

      <el-form-item class="contact-form__full" label="描述" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          placeholder="请输入需求描述"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import { provinceOptions, universityOptions } from '@/utils/options'
import { isEmail, isPhone } from '@/utils/validators'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])
const router = useRouter()
const formRef = ref()

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const form = reactive({
  name: '',
  phone: '',
  email: '',
  universityOption: '',
  province: '',
  universityName: '',
  grade: '',
  area: '',
  description: ''
})

const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isPhone(value)) {
          callback(new Error('请输入正确的手机号'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  email: [
    { required: true, message: '请输入电子邮箱', trigger: 'blur' },
    {
      validator: (_, value, callback) => {
        if (!isEmail(value)) {
          callback(new Error('请输入正确的邮箱格式'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  universityOption: [{ required: true, message: '请选择所在大学', trigger: 'change' }],
  province: [{ required: true, message: '请选择大学所在省份', trigger: 'change' }],
  universityName: [{ required: true, message: '请输入大学名称', trigger: 'blur' }],
  grade: [{ required: true, message: '请输入所在年级', trigger: 'blur' }],
  area: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  description: [{ required: true, message: '请输入描述信息', trigger: 'blur' }]
}

function handleSubmit() {
  formRef.value.validate((valid) => {
    if (!valid) {
      return
    }

    ElMessage.success('提交成功，正在进入个人中心')
    dialogVisible.value = false
    router.push('/profile')
  })
}
</script>

<style lang="scss" scoped>
.dialog-tip {
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 16px;
  color: var(--text-secondary);
  background: rgba(17, 88, 214, 0.06);
}

.contact-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.contact-form :deep(.el-form-item) {
  margin-bottom: 0;
}

.contact-form__full {
  grid-column: 1 / -1;
}

.contact-form :deep(.el-select) {
  width: 100%;
}

.contact-form :deep(.el-input__wrapper),
.contact-form :deep(.el-textarea__inner) {
  border-radius: 14px;
  min-height: 44px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}


@media (max-width: 768px) {
  :deep(.contact-dialog) {
    width: calc(100vw - 24px) !important;
    
  }

  .contact-form {
    grid-template-columns: 1fr;
  }

  .contact-form__full {
    grid-column: auto;
  }
}
</style>
